import { render, staticRenderFns } from "./BarcodeList.vue?vue&type=template&id=389a3d3f&"
import script from "./BarcodeList.vue?vue&type=script&lang=js&"
export * from "./BarcodeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports